import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b30d47a")

_pushScopeId("data-v-3b30d47a")
const _hoisted_1 = { class: "SBreadCrumbs" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.links, (link, i) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        class: "SBreadCrumbs__link",
        key: `link-${i}`,
        to: link.path
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(link.name), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
})